export const computeCollectPointFillRate = (collectPoint: any) => {
    if (collectPoint.storageCrates.length == 0) return 0
    let mean = 0;
    for (let i = 0; i < collectPoint.storageCrates.length; i++) {
        mean += collectPoint.storageCrates[i].fillRate;
    }
    return Math.round((mean / collectPoint.storageCrates.length))
}